'use client';

import { ArrowRight } from "lucide-react";

interface TProps {
    heading?: string
    subHeading?: string
    buttonText?: string
    buttonLink?: string
}

const PrimaryCTA = ({
    heading = "Ready to experience the difference?",
    subHeading = "",
    buttonText = "Let's Talk, We're Way Better",
    buttonLink = "#hero",
}: TProps) => {
    return (
        <section className="bg-primary py-12">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-8">
                    <h1 className="text-5xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-7xl leading-14 lg:leading-[1.2] text-center sm:text-left">
                        {heading}<br/>{subHeading}
                    </h1>
                    <a href={buttonLink} className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-white px-8 py-4 text-lg font-bold text-primary transition-all duration-300 hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2">
                        <span className="relative z-10 flex items-center">
                            {buttonText}
                            <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                        </span>
                    </a>
                </div>
        </section>
    );
};

export default PrimaryCTA;
